<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle"
            data-toggle="collapse"
            data-target="#navigation-example-2"
            @click="toggleNavbar"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <span class="navbar-brand">{{ ws.getSetting('portal_name') }}</span>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <router-link to="/register" tag="li">
              <a>
                <i class="fas fa-edit"></i> Register
              </a>
            </router-link>
            <router-link :to="{name: 'Home'}" tag="li">
              <a>
                <i class="fas fa-home"></i> Dashboard
              </a>
            </router-link>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div
        class="full-page login-page"
        data-color
        data-image="static/img/background/background-2.jpg"
      >
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <form method="#" action="#" @submit.prevent="resetPassword">
                  <div class="card" data-background="color" data-color="blue">
                    <div class="card-header">
                      <h3 class="card-title">Reset your password</h3>
                    </div>
                    <div class="card-content">
                      <div class="form-group">
                        <label>Email address</label>
                        <input
                          type="email"
                          v-model="email"
                          placeholder="Enter email"
                          class="form-control input-no-border"
                          v-validate="'required'"
                        >
                      </div>
                      <small class="text-danger" v-show="email.invalid">{{ getError('email') }}</small>
                      <div class="form-group">
                        <label>Password</label>
                        <input
                          type="password"
                          name="password"
                          ref="password"
                          v-model="password"
                          placeholder="At least one capital and a special character"
                          class="form-control input-no-border"
                          v-validate="'required|verify_password'"
                        >
                      </div>
                      <small class="text-danger" v-show="password.invalid">{{ getError('password') }}</small>
                      <div class="form-group">
                        <label>Retype password</label>
                        <input
                          type="password"
                          name="password_repeat"
                          v-model="password_repeat"
                          placeholder="Password repeat"
                          class="form-control input-no-border"
                          v-validate="'confirmed:password'"
                        >
                      </div>
                      <small
                        class="text-danger"
                        v-show="password_repeat.invalid"
                      >{{ getError('password_repeat') }}</small>
                    </div>
                    <div class="card-footer text-center">
                      <router-link
                        :to="{name: 'PasswordReset'}"
                        tag="div"
                        class="btn btn-warning btn-fill"
                        v-if="tokenExpired"
                      >
                        <i class="fas fa-exclamation-triangle"></i> token has expired.
                        <br>Click here to request a new password reset
                      </router-link>
                      <div class="clearfix"></div>
                      <br>
                      <button type="submit" :disabled="loading" class="btn btn-fill btn-wd" v-if="!tokenExpired">
                        <i class="fas" :class="{'fa-retweet' : !loading, 'fa-atom fa-spin': loading}"></i> Reset password
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              Powered by
              <a href="https://www.chiptuningreseller.com"><i class="fas fa-copyright"></i> ChiptuningReseller Platform</a>
            </div>
          </div>
        </footer>
        <div
          class="full-page-background"
          :style="{backgroundImage: 'url('+shuffledImage+')'}"
          style="'background:no-repeat center center fixed;'"
        ></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>Register</a>
        </router-link>
        <router-link to="/admin/overview" tag="li">
          <a>Dashboard</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vee-validate";
export default {
  computed: {
    ...mapFields(["email", "password", "password_repeat"])
  },
  data() {
    return {
      email: "",
      password: "",
      password_repeat: "",
      token: this.$route.params.token,
      tokenExpired: false,
      shuffledImage: "",
      loading:false
    };
  },
  mounted() {
    this.imageShuffler();
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    resetPassword() {
      this.$validator.validateAll().then(result => {
        this.loading = true;
        if (!result) {
          this.$notify({
                  component: {
                    template:
                      "<span>Something went wrong, did you enter all fields?</span>"
                  },
                  icon: "fas fa-exclamation-triangle",
                  horizontalAlign: "center",
                  verticalAlign: "top",
                  type: "error"
                });
                this.loading = false;
        } else {
          Webservice.passwordReset(this.email, this.password, this.token)
            .then(resp => {
              if (resp.data == "success") {
                this.$notify({
                  component: {
                    template:
                      "<span>Password reset! You can now login with your new password</span>"
                  },
                  icon: "fas fa-check",
                  horizontalAlign: "center",
                  verticalAlign: "top",
                  type: "success"
                });
                this.$router.push({ name: "Login" });
              }
            })
            .catch(error => {
              if (error.response.data.errors.token) {
                this.loading = false;
                this.tokenExpired = true;
                this.password = "";
                this.password_repeat = "";
                this.$notify({
                  component: {
                    template:
                      "<span>The reset token expired. Please request a new password reset.</span>"
                  },
                  icon: "fas fa-exclamation-triangle",
                  horizontalAlign: "center",
                  verticalAlign: "top",
                  type: "warning"
                });
                this.loading = false;
              }
            });
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate () {
        return this.$validator.validateAll()
      },
    imageShuffler() {
      var images = [
        "static/img/background/background-1.jpg",
        "static/img/background/background-2.jpg",
        "static/img/background/background-3.jpg",
        "static/img/background/background-4.jpg",
        "static/img/background/background-5.jpg"
      ];
      var shuffled = images[Math.floor(Math.random() * images.length)];
      if (!this.shuffledImage) {
        this.shuffledImage = "'" + shuffled + "'";
      }
    },
  },
  beforeDestroy() {
    this.closeMenu();
  },
  computed: {
    ws: () => {
      return Webservice;
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/PasswordReset.vue